import { t } from "i18next";
import * as Service from '../../Services/service';
import * as ClaimService from '../../Services/claim-service';
import { CustomDisabledTextfield, CustomTextField } from "../../Components/custom-textfield/CustomTextField";
function ClaimRequestInfo({ objectDto, setObjectDto, validate }) {
    return (
        <fieldset className="request-information" style={{ marginTop: "2%" }}>
            <div className="form-group col-md-12" >
                <label className="col-md-2 required description-small-customer">
                    {t("policynumber")}
                </label>
                <div className="col-md-4">
                    <CustomDisabledTextfield variant="outlined" label={""} size="small" fullWidth disabled value={objectDto.policyNo} />
                </div>
            </div>
            <label className="label-header description-large-customer">
                {t("claimpersonalrequest").toUpperCase()}
            </label>
            <div className="form-group col-md-12">
                <label className="col-md-2 description-small-customer">{t("fullname")}</label>
                <div className="col-md-4">
                    <CustomDisabledTextfield variant="outlined" label={""} size="small" fullWidth disabled value={objectDto.rqName} />
                </div>
                <label className="col-md-2 description-small-customer">{t("dob")}</label>
                <div className="col-md-4" style={{ marginBottom: "10px !important" }}>
                    <CustomDisabledTextfield variant="outlined" label={""} size="small" fullWidth disabled value={objectDto.strPoDob} />
                </div>
            </div>
            <div className="form-group col-md-12">
                <label className="col-md-2 description-small-customer">{t("idnumber")}</label>
                <div className="col-md-4">
                    <CustomDisabledTextfield variant="outlined" label={""} size="small" fullWidth disabled value={objectDto.idNumber} />
                </div>
                <label className="col-md-2 description-small-customer">{t("phone")}</label>
                <div className="col-md-4">
                    <CustomDisabledTextfield variant="outlined" label={""} size="small" fullWidth disabled value={objectDto.rqPhone} />
                </div>
            </div>
            <div className="form-group col-md-12">
                <label className="col-md-2 required description-small-customer">{t("email")}</label>
                <div className="col-md-4">
                    {objectDto.checked === 1 ?
                        <CustomTextField variant="outlined" label={""} size="small" required fullWidth focusColor="#c4960c" value={objectDto.email || null}
                            helperText={validate === true ? (ClaimService.validateValue(objectDto.email) === false ? t("NotEmptyjavalangString") :
                                objectDto.email !== undefined && !(Service.ValidateEmail(objectDto.email) || objectDto.email === '') ? t("errormessageinvalidemail") : "") : ""}
                            onChange={(e) => { setObjectDto({ ...objectDto, email: e.target.value }) }}
                        />
                        :
                        <CustomDisabledTextfield variant="outlined" label={""} size="small" fullWidth disabled value={objectDto.email || ''} />
                    }
                </div>
                <label className="col-md-2 required description-small-customer">{t("posaddresscontact")}</label>
                <div className="col-md-4">
                    {objectDto.checked === 1 ?
                        <CustomTextField variant="outlined" label={""} size="small" required fullWidth focusColor="#c4960c"
                            value={objectDto.contactAddress || ""}
                            helperText={validate && !(ClaimService.validateValue(objectDto.contactAddress)) ? t("NotEmptyjavalangString") : ""}
                            onChange={(e) => { setObjectDto({ ...objectDto, contactAddress: e.target.value }) }}
                        />
                        :
                        <CustomDisabledTextfield variant="outlined" label={""} size="small" fullWidth disabled value={objectDto.contactAddress || ""} />
                    }
                </div>
            </div>
        </fieldset>
    )
}
export default ClaimRequestInfo;